// extracted by mini-css-extract-plugin
export default {"pageHolder":"OrderDelivered_pageHolder__u7I10","itemHolder":"OrderDelivered_itemHolder__c0ahU","dateHolder":"OrderDelivered_dateHolder__0sKLK"};